var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center jobs-overview-scroll-menu"},[_c('strong',[_vm._v(_vm._s(_vm.numJobs)+" "+_vm._s(_vm.$tc('jobs.joboffers', _vm.numJobs)))]),_c('span',{staticClass:"ml-auto"},[_c('jobalert-dialog')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }